import React from "react";
import { LoadingIndicator } from "@quintype/components";

import { SvgIconHandler } from "../SvgIconHandler";

import "./loading-indicator.m.css";

const LoadingIndicatorComponent = ({ loading }) => {
  if (!loading) return null;
  return (
    <div className={`loading-indicator ${loading ? "loading-indicator-loading" : ""}`}>
      <div styleName="qt-loading-animation">
        <SvgIconHandler type="loading" width="64px" height="64px" />
      </div>
    </div>
  );
};

export default LoadingIndicatorComponent;
